import { Route, Routes } from "react-router-dom";

import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import NotFound from "./components/NotFound";
import ProjectDescrition from "./components/ProjectDescrition";

function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <div className="App">
            <NavBar />
            <Banner />
            <Skills />
            <Projects />
            <Contact />
            <Footer />
          </div>
        }
      />
      <Route path="*" element={<NotFound />} />
      <Route path="project/:id" element={<ProjectDescrition />} />
    </Routes>
  );
}

export default App;
